import AlternativeSpinner from './AlternativeSpinner'
import Multiselection from './Multiselection'
import Uniselection from './Uniselection'

import { textSizings } from './enum'

import { Label, ComponentStructure } from './styles'

import { ExplicitSelectionButtonProps, InputProps } from './type'

const componentByType = {
  uniselection: Uniselection,
  multiselection: Multiselection
}

const ExplicitSelectionButton = ({
  label,
  options,
  onChange,
  isProcessing = false,
  direction = 'horizontal',
  heightClass = 'regular',
  optionLabelsPosition = 'top',
  selectionType = 'uniselection',
  required = false,
  ...props
}: ExplicitSelectionButtonProps) => {
  const SelectionComponent = componentByType[
    selectionType
  ] as React.FC<InputProps>

  const isBeforePositioned =
    optionLabelsPosition === 'top' || optionLabelsPosition === 'left'

  return (
    <ComponentStructure direction={direction} aria-required={required}>
      <ComponentStructure direction={direction}>
        <Label
          heightClass={heightClass}
          direction={direction}
          isBeforePositioned={isBeforePositioned}
          optionLabelsPosition={optionLabelsPosition}
          variant={textSizings[heightClass].label}
        >
          {label}
        </Label>

        <SelectionComponent
          heightClass={heightClass}
          options={options}
          onChange={onChange}
          direction={direction}
          optionLabelsPosition={optionLabelsPosition}
          {...props}
        />

        {isProcessing && (
          <AlternativeSpinner
            direction={direction}
            heightClass={heightClass}
            isBeforePositioned={isBeforePositioned}
            optionLabelsPosition={optionLabelsPosition}
          />
        )}
      </ComponentStructure>
    </ComponentStructure>
  )
}

export default ExplicitSelectionButton
